<svg:path
	animate.enter="draw-path"
	fill="none"
	pathLength="100"
	[attr.d]="curve()"
	[attr.stroke]="strokeColor()"
	[attr.stroke-width]="lineWidth()"
/>
